import { render, staticRenderFns } from "./OtrosPermisoView.vue?vue&type=template&id=7285fe09&scoped=true"
import script from "./OtrosPermisoView.vue?vue&type=script&lang=js"
export * from "./OtrosPermisoView.vue?vue&type=script&lang=js"
import style1 from "./OtrosPermisoView.vue?vue&type=style&index=1&id=7285fe09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7285fe09",
  null
  
)

export default component.exports